import axios from 'axios';
import { BACKEND_API_URL } from '../config/api';

export default axios.create({
    baseURL: BACKEND_API_URL,
    withCredentials: true 
});